import { render } from "./TheHeader.vue?vue&type=template&id=c664dd8a"
import script from "./TheHeader.vue?vue&type=script&lang=js"
export * from "./TheHeader.vue?vue&type=script&lang=js"

import "./TheHeader.vue?vue&type=style&index=0&id=c664dd8a&lang=css"
script.render = render

export default script